module.exports = __webpack_public_path__ + "img/9791195628308.c552aedc.jpg";